// extracted by mini-css-extract-plugin
export var printerCard = "_i8-1";
export var printerCardConfigured = "_i8-2";
export var printerCardError = "_i8-3";
export var printerCardsContainer = "_i8-0";
export var printerIcon = "_i8-8";
export var printerIconConfigured = "_i8-5";
export var printerIconContainer = "_i8-4";
export var printerIconError = "_i8-6";
export var printerIconUnconfigured = "_i8-7";
export var workstationsTableCard = "_i8-9";